import { compare } from '../unknowns/compare';

export const hasDuplicateItems = <T>(arr: T[], equalityCondition: (el1: T, el2: T) => boolean = compare): boolean =>
  getDuplicateItems(arr, equalityCondition).length > 0;

export const getDuplicateItems = <T>(arr: T[], equalityCondition: (el1: T, el2: T) => boolean = compare): T[] =>
  arr.filter((el, index) => arr.findIndex(e => equalityCondition(el, e)) !== index);
